import IconDelete from "../../../Common/Icons/IconDelete";

export function UploadedImageCard(props: {
  file?: any;
  handleFileChange?: any;
}) {
  return (
    <div className="relative w-[160px] flex justify-center rounded-lg bg-brij-White p-2 h-full">
      <div className="absolute w-full flex justify-end px-2">
        <button
          className="bg-brij-DarkGrey hover:bg-brij-Black opacity-80 p-1 rounded-lg "
          onClick={() => {
            props.handleFileChange(null);
          }}
        >
          <div className="h-7 w-7 stroke-brij-White">
            <IconDelete />
          </div>
        </button>
      </div>

      {props.file && props.file.type.match("image.*") && (
        <img
          src={URL.createObjectURL(props.file)}
          alt={props.file}
          className="object-contain"
        />
      )}
    </div>
  );
}
